import * as tslib_1 from "tslib";
import FeatureFlagListItem from './FeatureFlagsListItem';
import { observer } from 'mobx-react';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { featureFlags } from 'owa-feature-flags';
import * as React from 'react';
/* tslint:disable:forbid-import */
import { action, observable } from 'mobx';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
/* tslint:enable:forbid-import */
var styles = require('./FeatureFlagsList.scss');
var classNames = require('classnames/bind');
var FeatureFlagsList = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsList, _super);
    function FeatureFlagsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { className: classNames(styles.searchBoxContainer, isControlFeatureEnabled('fwk-o365shellheader') && styles.noDark) },
                React.createElement(SearchBox, { labelText: "Filter feature flags", onChanged: this.onFilterTextChanged.bind(this) })),
            featureFlags
                .keys()
                .sort()
                .filter(function (key) {
                return !_this.filterText ||
                    key.toLowerCase().indexOf(_this.filterText.toLowerCase()) > -1;
            })
                .map(function (key) { return (React.createElement(FeatureFlagListItem, { name: key, key: key, isOn: featureFlags.get(key) })); })));
    };
    FeatureFlagsList.prototype.onFilterTextChanged = function (filterText) {
        this.filterText = filterText;
    };
    tslib_1.__decorate([
        observable
    ], FeatureFlagsList.prototype, "filterText", void 0);
    tslib_1.__decorate([
        action
    ], FeatureFlagsList.prototype, "onFilterTextChanged", null);
    FeatureFlagsList = tslib_1.__decorate([
        observer
    ], FeatureFlagsList);
    return FeatureFlagsList;
}(React.Component));
export default FeatureFlagsList;
//# sourceMappingURL=FeatureFlagsList.js.map